import { AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  Output,
  EventEmitter,
  ChangeDetectionStrategy } from '@angular/core';
import { ChatPipe } from '@k12/pipes';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MessageCenterService } from '@k12/messaging';
import { MsalService } from '@azure/msal-angular';
import { isSameAccountToken } from '@k12/app-services';
import { Message, Thread } from '../message-center.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-message-center-chat-interface, [chat-interface]',
  standalone: true,
  imports: [ChatPipe, CommonModule, MatProgressBarModule, MatTooltipModule, MatIconModule, MatButtonModule],
  templateUrl: './message-center-chat-interface.component.html',
  styleUrl: './message-center-chat-interface.component.scss'
})
export class MessageCenterChatInterfaceComponent implements AfterViewInit, OnChanges {
  private readonly msalService: MsalService = inject(MsalService);
  private readonly accountId?: string = '';
  private readonly messageService: MessageCenterService = inject(MessageCenterService);

  @Input() thread: Thread | null = null; // active chat context
  @Input() loadingMessages: boolean = false;
  @Input() locale: string = 'en-US';

  @Output() scrollDown = new EventEmitter<void>();

  constructor() {
    this.accountId = this.msalService.instance.getActiveAccount()?.localAccountId;
  }

  public getFormattedTime(date: Date | string | undefined): string {
    return this.messageService.getFormattedTime(date);
  }

  public getMessageClass(item: Message) {
    return this.isMessageSender(item) ? 'chat_message right' : 'chat_message left';
  }

  protected isMessageSender(item: Message) {
    return isSameAccountToken(item.senderId, this.accountId);
  }

  public ngAfterViewInit(): void {
    queueMicrotask(() => this.scrollDown.emit());
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['thread']) {
      queueMicrotask(() => this.scrollDown.emit());
    }
  }

  protected escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}
